export default [
  {
    path: '/classcard/moral/',
    name: 'PageMoralEvaluationMultiRoleIndex',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/moral/PageMoralEvaluationMultiRoleIndex'
      ),
    meta: {
      modular: 20,
      title: '德育考评',
      info: '德育考评——多角色入口',
      keepAlive: true
    }
  },
  {
    path: '/classcard/moral/studentStatistic',
    name: 'PageMoralEvaluationStudentStatistic',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/moral/PageMoralEvaluationStudentStatistic'
      ),
    meta: {
      modular: 20,
      title: '考评详情',
      info: '德育考评——统计',
      keepAlive: true
    }
  },

  {
    path: '/classcard/moral/chooseBatchStudent',
    name: 'PageMoralEvaluationChooseBatchStudent',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/moral/PageMoralEvaluationChooseBatchStudent'
      ),
    meta: {
      modular: 20,
      title: '我要考评',
      info: '德育考评——我要考评——批量选择',
      keepAlive: true
    }
  },
  {
    path: '/classcard/moral/batchStudent',
    name: 'PageMoralEvaluationBatchStudent',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/moral/PageMoralEvaluationBatchStudent'
      ),
    meta: {
      modular: 20,
      title: '图文点评',
      info: '德育考评——批量考评——批量提交',
      keepAlive: true
    }
  },
  {
    path: '/classcard/moral/records',
    name: 'PageMoralEvaluationRecords',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/moral/PageMoralEvaluationRecords'
      ),
    meta: {
      modular: 20,
      title: '明细',
      info: '德育考评——考评明细',
      keepAlive: true
    }
  },
  {
    path: '/classcard/moralstudent',
    name: 'PageMoralStudent',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/moral/PageMoralStudent'
      ),
    meta: {
      modular: 20,
      title: '德育考评',
      info: '德育考评——学生',
      keepAlive: true
    }
  },
  {
    path: '/classcard/moralaudit',
    name: 'PageMoralAudit',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/moral/PageMoralAudit'
      ),
    meta: {
      modular: 20,
      title: '我的审核',
      info: '德育考评——我的审核',
      keepAlive: true
    }
  },
  {
    path: '/classcard/moralexport',
    name: 'PageMoralExport',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/moral/PageMoralExport'
      ),
    meta: {
      modular: 20,
      title: '导出德育报表',
      info: '德育考评——导出报表',
      keepAlive: true
    }
  },
  {
    path: '/classcard/audioFilter',
    name: 'PageAudioFilter',
    component: () =>
      import(/* webpackChunkName: "classcard" */ '../pages/moral/PageFilter'),
    meta: {
      modular: 20,
      title: '筛选',
      info: '德育考评——班牌筛选',
      keepAlive: true
    }
  }
]
